var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.151 4.651a.5.5 0 0 1 .707 0L8 7.793l3.142-3.142a.5.5 0 1 1 .707.707L8.707 8.5l3.142 3.142a.5.5 0 0 1-.707.707L8 9.207 4.858 12.35a.5.5 0 1 1-.707-.707L7.293 8.5 4.15 5.358a.5.5 0 0 1 0-.707",
    clipRule: "evenodd"
  })));
};
export default SvgCloseIcon;